import { render, staticRenderFns } from "./UsuarioLista.vue?vue&type=template&id=1acc7b70&scoped=true"
import script from "./UsuarioLista.vue?vue&type=script&lang=js"
export * from "./UsuarioLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc7b70",
  null
  
)

export default component.exports